module.exports = __webpack_public_path__ + "img/bulgaria.025faaf6.png";